import React, { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { preloadImages, getOptimizedImageUrl } from '../utils/imageOptimization';
import './Hero.css';

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [heroContent, setHeroContent] = useState({
    heroEyebrow: 'Cassette 2025 Capsule',
    heroTitle: 'THE TAG Atelier',
    heroCopy: 'Fluid silhouettes, sheer layers, and enduring craftsmanship. Discover abayas designed to feel as weightless as the desert air.',
    heroButton1: 'Shop Abayas',
    heroImages: [
      'https://images.unsplash.com/photo-1583391265014-e66c3a7e92b6?w=1920&q=80',
      'https://images.unsplash.com/photo-1581338834647-b0fb40704e21?w=1920&q=80',
      'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=1920&q=80'
    ]
  });

  useEffect(() => {
    const fetchHeroContent = async () => {
      try {
        const homepageRef = doc(db, 'homepage', 'content');
        const docSnap = await getDoc(homepageRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setHeroContent({
            heroEyebrow: data.heroEyebrow || heroContent.heroEyebrow,
            heroTitle: data.heroTitle || heroContent.heroTitle,
            heroCopy: data.heroCopy || heroContent.heroCopy,
            heroButton1: data.heroButton1 || heroContent.heroButton1,
            heroImages: data.heroImages || heroContent.heroImages,
          });
        }
      } catch (error) {
        console.error('Error fetching hero content:', error);
      }
    };
    fetchHeroContent();
  }, []);

  useEffect(() => {
    if (heroContent.heroImages.length > 0) {
      // Preload all hero images for faster transitions
      const optimizedImages = heroContent.heroImages
        .filter(img => img)
        .map(img => getOptimizedImageUrl(img, 'hero'));
      preloadImages(optimizedImages).catch(err => {
        console.warn('Failed to preload some hero images:', err);
      });

      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % heroContent.heroImages.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [heroContent.heroImages]);

  return (
    <section className="hero" id="home">
      <div className="hero-slider">
        {heroContent.heroImages.filter(img => img).map((image, index) => {
          const optimizedImage = getOptimizedImageUrl(image, 'hero');
          return (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'is-active' : ''}`}
              style={{ backgroundImage: `url(${optimizedImage})` }}
            ></div>
          );
        })}
      </div>

      <div className="hero-pagination">
        {heroContent.heroImages.filter(img => img).map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'is-active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Show slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default Hero;
